import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { useAuthStore } from './stores/auth';
import { initSentry } from './sentry';
import './style.css';

const app = createApp(App);
app.use(createPinia());
app.use(router);
initSentry(app, router);

// Tenta restaurar o usuário a partir do token persistido antes de montar.
useAuthStore().bootstrap().finally(() => {
    app.mount('#app');
});
